/**
 * responsive helper library
 * @author Tobias Schubert (ts@taikonauten.com)
 */

import { trigger } from './event';
import { breakpoints } from '../config/responsive';

class Responsive {

  constructor() {

    this.oldBreakpoint = undefined;
    // holds the current breakpoint as a string that is equal to the current breakpoint identifier
    this.currentBreakpoint = undefined;
    this.breakpointClasses = [];

    // our breakpoints as defined in our config
    this.breakpoints = breakpoints;

    // indicates if we are currently in landscape
    this.landscape = undefined;

    this.resizeDebounceTimer = undefined;

    this.init();
  }

  init() {

    this.setBreakpointClasses();
    this.registerEvents();
  }

  registerEvents() {
    // Adding a debounce
    window.addEventListener('resize', () => {
      window.clearTimeout(this.resizeDebounceTimer);
      this.resizeDebounceTimer = window.setTimeout(() => {
        this.onResizeListener.bind(this);
      }, 100);
    }, false);
    this.onResizeListener();
  }

  /**
   * Generate all breakpoint classes as defined in the responsive config.
   * All breakpoint classes are in the form breakpoint-[identifier]
   */
  setBreakpointClasses() {

    this.breakpoints.forEach(breakpoint => {

      this.breakpointClasses.push(`breakpoint-${breakpoint.identifier}`);
    });
  }

  getBreakpoint() {

    return this.currentBreakpoint;
  }

  /**
   * checks in which of the defined breakpoint we are.
   * if the breakpoint differs from the the breakpoint that was set upon last call
   * the setBreakpointClass and trigger methods are called.
   */
  onResizeListener() {

    this.oldBreakpoint = this.currentBreakpoint;

    this.landscape = matchMedia('(orientation: landscape)').matches;
    this.breakpoints.every((breakpoint, index) => {
      if (matchMedia('(max-width: ' + (breakpoint.min - 1) + 'px)').matches) {
        this.currentBreakpoint = this.breakpoints[index - 1].identifier;
        return false;
      }

      if (index === this.breakpoints.length - 1) {

        this.currentBreakpoint = this.breakpoints[this.breakpoints.length - 1].identifier;
        return false;
      }

      return true;
    });

    if (this.oldBreakpoint === this.currentBreakpoint) {
      return;
    }

    this.setBreakpointClass();
    this.trigger();
  }

  /**
   * set the current breakpoint class to our document element
   */
  setBreakpointClass() {

    this.breakpointClasses.forEach(breakpointClass => {

      document.documentElement.classList.remove(breakpointClass);
    });

    document.documentElement.classList.add(`breakpoint-${this.currentBreakpoint}`);
  }

  /**
   * fires two event on each breakpoint change you can listen to.
   */
  trigger() {

    trigger(window, `${this.currentBreakpoint}Breakpoint`);
    trigger(window, 'changeBreakpoint');
  }
}

const responsive = new Responsive();
export default responsive;
export let currentBreakpoint = responsive.currentBreakpoint;
